import React from 'react'
import styled from 'styled-components'

const StylishSpacer = styled.div`
  padding-top: ${props => props.amount}rem;
`

export const Spacer = ({ amount }) => {
  return <StylishSpacer amount={amount} />
}
